// ---------------------------------------------------------------------------
// This file drives the Resume, Skills, Portfolio, Work and Testimonials
// sections of the site. To add a NEW PROJECT later without breaking the
// layout, copy one of the objects inside `projects` below and:
//   1. Give it a unique `image` filename (and place that image at
//      src/images/portfolio/<filename>).
//   2. Keep every field present (title, category, technology, summary,
//      description, image, url, github, animation) - the components below
//      expect all of them to exist.
// The grid/sections are all rendered with .map(), so adding or removing
// items from these arrays is safe and will never break the design.
// ---------------------------------------------------------------------------
const resumeData = [
  {
    skillmessage:
      "I have honed my full-stack web development skills (MERN Stack) over the past 3+ years, building responsive, high-performance websites and web applications.",
    education: [
      {
        school: "National University, Dhaka, Bangladesh",
        degree: "MBA in Management",
        graduated: "2021",
        description: "",
      },
      {
        school: "Udemy",
        degree: "Web Development / Programming Courses",
        graduated: "",
        description:
          "Online courses covering modern web development tools and best practices.",
      },
      {
        school: "Programming Hero",
        degree: "Programming Fundamentals & Web Development",
        graduated: "",
        description:
          "A comprehensive program covering programming fundamentals and full web development workflow.",
      },
    ],
    work: [
      {
        company: "Booklink IT, Rampura, Dhaka",
        title: "Full Stack Web Developer",
        years: "January 2022 - Present",
        description: `1. Developed and maintained the company's main website and several client websites.
 2. Built a comprehensive doctor portal enabling users to search for doctors by district, with an admin-controlled request/approval and blocking workflow.
 3. Implemented QR code generation and QR-based scanning login for doctor profiles.
 4. Implemented RESTful APIs to enhance site functionality and ensured cross-browser compatibility and responsiveness.
 5. Performed on-page SEO optimization (meta tags, semantic HTML, sitemap, page speed) on client websites to improve search visibility.
 6. Gathered and analyzed business requirements from clients and translated them into technical specifications and feature plans.
 7. Participated in agile development processes and contributed to sprint planning.`,
      },
      {
        company: "Unicon Solution Limited, New Elephant, Dhaka",
        title: "Full Stack Web Developer",
        years: "November 2020 - December 2021",
        description: `1. Led development of a scalable multi-vendor e-commerce platform (2000+ products) using React and Node.js, allowing multiple sellers to manage their own products and orders.
 2. Implemented secure SSL-based online payment processing to ensure safe customer transactions.
 3. Built a secured API-key-based third-party integration and a system to generate and manage gift cards and discount tokens.
 4. Developed an admin dashboard for full control over products, orders, and vendors, and improved overall website performance through code optimization.
 5. Provided eScan antivirus technical support.`,
      },
      {
        company: "answarIT, Remote",
        title: "Full Stack Web Developer (Intern)",
        years: "March 2020 - September 2020",
        description: `1. Assisted in developing and maintaining the company's main website and client sites.
 2. Participated in agile development processes and code reviews.
 3. Fixed bugs and collaborated with senior developers and designers.`,
      },
    ],
    skills: [
      {
        name: "JavaScript",
        level: "90%",
      },
      {
        name: "React.js / Next.js",
        level: "85%",
      },
      {
        name: "Html5 & Css3",
        level: "95%",
      },
      {
        name: "Node.js & Express.js",
        level: "85%",
      },
      {
        name: "MongoDB",
        level: "80%",
      },
      {
        name: "Tailwind / Bootstrap / MUI",
        level: "85%",
      },
      {
        name: "SEO & Optimization",
        level: "75%",
      },
      {
        name: "Sass",
        level: "70%",
      },
    ],

    projects: [
      {
        titleHead: "Food Ordering & E-commerce Platform",
        title: "Dishco Food - Food Ordering & E-commerce Platform",
        category:
          "Dishco Food built with MERN Stack (MongoDB, ExpressJS, ReactJS, NodeJS) and SSLCOMMERZ for secure payments.",
        technology: ["React", "Node", "MongoDB", "Ecommerce"],
        summary:
          "I built a full food ordering platform covering the complete flow from food listing to online ordering, real-time order tracking, and a full-featured e-commerce admin dashboard, with a loyalty system and pre-order scheduling.",
        description: [
          "1. Built a full food ordering platform covering the complete flow from food listing to online ordering, real-time order tracking, and a full-featured e-commerce admin dashboard.",
          "2. Designed a loyalty system with earned points and coupon-based discounts to encourage repeat orders.",
          "3. Implemented day-wise ordering and a pre-order system, letting customers schedule orders in advance.",
          "4. Integrated SSLCOMMERZ for secure online payment processing.",
          "5. Live link: dishcofood.com",
        ],
        image:
          "https://res.cloudinary.com/dtixzwuqt/image/upload/v1789671368/d1_yucl8q.png",
        url: "https://dishco-foodbd.netlify.app/",
        github: "https://github.com/jahid777",
        animation: "fade-right",
      },
      {
        titleHead: "Multi-Vendor E-commerce Platform",
        title: "Shokh Station - Multi-Vendor E-commerce Platform",
        category:
          "Shokh Station built with MERN Stack (MongoDB, ExpressJS, ReactJS, NodeJS) and SSLCOMMERZ for secure payments.",
        technology: ["React", "Node", "MongoDB", "Ecommerce"],
        summary:
          "I built a full-featured multi-vendor e-commerce platform with a dedicated vendor dashboard, letting multiple sellers manage their own products and orders, plus a complete admin dashboard for product, order, vendor, and category management.",
        description: [
          "1. Built a full-featured multi-vendor e-commerce platform with a dedicated vendor dashboard, allowing multiple sellers to manage their own products and orders.",
          "2. Developed a complete admin dashboard for product, order, vendor, and category management.",
          "3. Implemented core e-commerce functionality including product catalog with categories, cart & checkout, order history, and customer reviews & ratings.",
          "4. Integrated SSLCOMMERZ for secure online payment processing.",
          "5. Live link: https://shokhstation.vercel.app",
        ],
        image:
          "https://res.cloudinary.com/dtixzwuqt/image/upload/v1789676012/Screenshot_2026-09-18_021320_eznurt.png",
        url: "https://shokhstation.vercel.app",
        github: "https://github.com/jahid777",
        animation: "fade-left",
      },
      {
        titleHead: "Vape Inventory & Sales Management System",
        title: "Vapuu - Vape Inventory & Sales Management System",
        category:
          "Vapuu built with MERN Stack (MongoDB, ExpressJS, ReactJS, NodeJS).",
        technology: ["React", "Node", "MongoDB"],
        summary:
          "I built a full inventory and sales management web app for a vape business, evolving it from a single-file prototype into a complete MERN application, with a Sales module offering color-wise summaries and a dedicated reporting API.",
        description: [
          "1. Built a full inventory and sales management web app for a vape business, evolving it from a single-file prototype into a complete MERN application.",
          "2. Designed a Sales module with color-wise sales summaries and a dedicated aggregation API endpoint for reporting.",
          "3. Implemented admin controls for editing and deleting sales records with automatic stock reconciliation.",
          "4. Added full mobile responsiveness, including a hamburger navigation menu, card-based list views, and bottom-sheet modals.",
          "5. Live link: vapuu.netlify.app",
        ],
        image:
          "https://res.cloudinary.com/dtixzwuqt/image/upload/v1789671555/vapu1_epi3oz.png",
        url: "https://vapuu.netlify.app/",
        github: "https://github.com/jahid777",
        animation: "fade-right",
      },
      {
        titleHead: "Online Library / Bookstore E-commerce",
        title: "Bookworm - Online Library",
        category:
          "Bookworm built with MERN Stack (MongoDB, ExpressJS, ReactJS, NodeJS).",
        technology: ["Next.js", "Node", "MongoDB"],
        summary:
          "I developed a responsive online bookstore for browsing and purchasing books, with reusable book cards, a visually appealing product listing layout, and a full shopping cart and order placement flow.",
        description: [
          "1. Developed a responsive online bookstore for browsing and purchasing books.",
          "2. Implemented user registration, login, and account management.",
          "3. Designed and developed reusable book cards and a visually appealing product listing layout.",
          "4. Integrated shopping cart and order placement functionality for a seamless purchasing experience.",
          "5. Live link: bookworm-seven.vercel.app",
        ],
        image:
          "https://res.cloudinary.com/dtixzwuqt/image/upload/v1789671664/bookworm_mdmzlv.png",
        url: "https://bookworm-seven.vercel.app",
        github: "https://github.com/jahid777",
        animation: "fade-left",
      },
      {
        titleHead: "DotMail - Business Website",
        title: "DotMail",
        category:
          "DotMail is a modern and fully responsive business website designed with a clean, professional, and eye-catching user interface.",
        technology: ["React.js"],
        summary:
          "I developed a modern and fully responsive business website with a clean design, smooth user experience, and eye-catching visual presentation.",
        description: [
          "1. Developed a fully responsive business website optimized for desktop, tablet, and mobile devices.",
          "2. Designed a modern, clean, and eye-catching user interface to create a strong business presence.",
          "3. Implemented reusable React components for a scalable and maintainable frontend.",
          "4. Focused on smooth navigation, responsive layouts, and an intuitive user experience.",
          "5. Integrated backend functionality using Node.js and MongoDB.",
          "6. Optimized the website for usability, performance, and cross-device compatibility.",
        ],
        image:
          "https://res.cloudinary.com/dtixzwuqt/image/upload/v1789672635/BUSINESS_z70es5.png",
        url: "https://dotmailit.netlify.app/",
        github: "https://github.com/jahid777",
        animation: "fade-left",
      },
    ],
    testimonials: [
      {
        text: "Client testimonials will be added here soon. Reach out if you'd like to be among the first to share your experience working with me.",
        user: "Your client's name",
      },
      {
        text: "This space is reserved for feedback from people I've worked with. Check back soon for real reviews.",
        user: "Your client's name",
      },
    ],
  },
];

export default resumeData;
